export default __webpack_public_path__ + "static/kirim-e67dd67a315f02fef4c890b7e9b34955.png";